<template>
  <section class="seo-description">
    <h2 class="seo-description__title">{{ title }}</h2>
    <p class="seo-description__text">{{ description }}</p>
  </section>
</template>

<script setup lang="ts">
interface Props {
  title: string
  description: string
}

defineProps<Props>()
</script>

<style scoped lang="scss">
@use 'sass:color';
.seo-description {
  width: 100%;
  margin-top: 3rem;
  padding: 2rem;
  background: color.scale($surface, $lightness: 3%);
  border-radius: 8px;
  line-height: 1.6;

  &__title {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: $text-light-200;
  }

  &__text {
    font-size: 0.95rem;
    color: $text-light-100;
    white-space: pre-line;
  }
}

@media (max-width: 768px) {
  .seo-description {
    margin: 0;
    padding: 1.5rem;

    &__title {
      font-size: 1.25rem;
    }

    &__text {
      font-size: 0.9rem;
    }
  }
}
</style>
